import type { Account } from '../../generated-types';

export default (account?: Account) => {
    return typeof account?.numberOfApprovers === 'number' && account.numberOfApprovers > 1;
};
